import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

import pdf from '../assets/documents/Campus_Security_Act_Disclosure_2024.1.pdf'

const pdfStyle = {
  width: '100%',
  height: '80vh',
}

const Pdf = props => (
  <Layout>
    <Helmet>
      <title>
        Thanh Le College, School of Cosmetology - Campus Security Act Disclosure
      </title>
      <meta name="description" content="Generic Page" />
    </Helmet>
    <div id="main" className="alt">
      <section id="one">
        <div className="inner">
          <header className="major">
            <h1>Campus Secuirty Act Disclosure</h1>
          </header>
          <iframe
            src={pdf + '#view=fit'}
            width="100%"
            height="100%"
            style={pdfStyle}
            title="School Catalog"
          />
        </div>
      </section>
    </div>
  </Layout>
)

export default Pdf
